module.exports = __webpack_public_path__ + "static/media/track-order.0dd8f7c9.svg";